import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import ImportServiceModal from "./partials/ImportServiceModal";


import {
    getServices as onGetServices,
    addNewService as onAddNewService,
    updateService as onUpdateService,
    deleteService as onDeleteService,

    getFaculties as onGetFaculties,

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Service = () => {

    //meta title
    document.title = "Services | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [service, setService] = useState(null);
    
    const [modalOpen, setModalOpen] = useState(false);


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (service && service.id) || '',
            uid: (service && service.uid) || '',
            name: (service && service.name) || '',
            code: (service && service.code) || '',
            faculty_id: (service && service.faculty_id) || '',
            description: (service && service.description) || '',
            is_active: (service && service.is_active) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le nom"),
            code: Yup.string().required("Veuillez saisir le code"),
            faculty_id: Yup.string().required("Veuillez sélectionner la faculté"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateService = {
                    id: values.id,
                    uid: values.uid,
                    name: values.name,
                    code: values.code,
                    faculty_id: values.faculty_id,
                    description: values.description,
                    is_active: values.is_active,
                    
                };
                // update movie category
                dispatch(onUpdateService(updateService));
                validation.resetForm();
            } else {
                const newService = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                    code: values["code"],
                    faculty_id: values["faculty_id"],
                    description: values["description"],
                    is_active: values["is_active"],
                   
                };
                // save new movie category
                dispatch(onAddNewService(newService));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const ServiceProperties = createSelector(
        (state) => state.serviceReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (serviceReducer) => ({
            services: serviceReducer.services,
            loading: serviceReducer.loading
        })
    );

    const {services, loading} = useSelector(ServiceProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {

        
        if (services && !services.length) {
            console.log("ON L")
            dispatch(onGetServices());
        }
    }, [dispatch, services]);


    // Faculties
        const FacultyProperties = createSelector(
            (state) => state.facultyReducer, 
            (facultyReducer) => ({
                faculties: facultyReducer.faculties,
                loading: facultyReducer.loading
            })
        );
    
        const {faculties} = useSelector(FacultyProperties);
    
    
        
    
        useEffect(() => {
            if (faculties && !faculties.length) {
                dispatch(onGetFaculties());
            }
        }, [dispatch, faculties]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setService(null);
        } else {
            setModal(true);
        }
    };

    const handleServiceClick = arg => {
        const service = arg;
        setService({
            id: service.id,
            uid: service.uid,
            name: service.name,
            code: service.code,
            faculty_id: service.faculty_id,
            description: service.description,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setService(branch);
        setDeleteModal(true);
    };

    const handleDeleteService = () => {
        if (service && service.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteService(service));
            setDeleteModal(false);
        }
    };

    const onClickNewService = () => {
        setIsEdit(false);
        setService(null);
        toggle();
        //setModal(true)
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Faculté",
                accessorKey: "faculty.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleServiceClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteService}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Services" breadcrumbItem="Liste des services" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>

                                                    <Link to="#!" onClick={onClickNewService} className="btn btn-primary me-1">Ajouter un service</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={services || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Service" : "Ajouter - Service"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Code</Label>
                                            <Input
                                                name="code"
                                                type="text"
                                                placeholder="Code"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.code || ""}
                                                invalid={
                                                    validation.touched.code && validation.errors.code ? true : false
                                                }
                                            />
                                            {validation.touched.code && validation.errors.code ? (
                                                <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Faculté</Label>
                                            <Input
                                                name="faculty_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.faculty_id || ""
                                                }
                                                invalid={
                                                    validation.touched.faculty_id && validation.errors.faculty_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {faculties.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.faculty_id && validation.errors.faculty_id ? (
                                                <FormFeedback type="invalid">{validation.errors.faculty_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Description</Label>
                                            <Input
                                                name="description"
                                                placeholder="Description"
                                                type="textarea"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={
                                                    validation.touched.description && validation.errors.description ? true : false
                                                }
                                            />
                                            {validation.touched.description && validation.errors.description ? (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            ) : null}
                                        </div>

                                        
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />

            <ImportServiceModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />

        </React.Fragment>
    );
}


export default Service;